import { TransformDate } from '../../../shared/decorators/transform-date.decorator';

/**
 * Vehicle availability params
 */
export class VehicleAvailabilityParams {
	/**
	 * Available from date
	 */
	@TransformDate()
	dateFrom?: Date;

	/**
	 * Available to date
	 */
	@TransformDate()
	dateTo?: Date;
}
